var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.8598 7.17131C19.6893 6.62863 19.3487 6.15522 18.8883 5.82109C18.4279 5.48697 17.8723 5.30986 17.3035 5.31597H13.662L12.5559 1.86868C12.382 1.32605 12.0402 0.852677 11.5799 0.516825C11.1196 0.180974 10.5645 0 9.99465 0C9.42482 0 8.86972 0.180974 8.40939 0.516825C7.94905 0.852677 7.60728 1.32605 7.43335 1.86868L6.32732 5.31597H2.68582C2.11884 5.31678 1.56661 5.49674 1.10802 5.83015C0.649428 6.16357 0.307926 6.63337 0.132295 7.17247C-0.0433363 7.71156 -0.0441136 8.29237 0.130074 8.83194C0.304262 9.3715 0.644504 9.84222 1.1022 10.1769L4.06607 12.3439L2.9392 15.8337C2.7571 16.375 2.75479 16.9606 2.93263 17.5033C3.11046 18.0459 3.45892 18.5166 3.92605 18.8451C4.38517 19.1841 4.94156 19.3658 5.5123 19.3629C6.08303 19.3601 6.63758 19.1729 7.09329 18.8293L9.99465 16.6939L12.8968 18.8268C13.3551 19.1639 13.9085 19.347 14.4774 19.3497C15.0464 19.3525 15.6015 19.1748 16.0631 18.8422C16.5246 18.5096 16.8688 18.0392 17.0462 17.4986C17.2235 16.958 17.2249 16.3751 17.0501 15.8337L15.9232 12.3439L18.8904 10.1769C19.3534 9.84642 19.6976 9.37571 19.8722 8.8344C20.0468 8.29309 20.0424 7.70995 19.8598 7.17131Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIco);
export default __webpack_public_path__ + "static/media/starIco.456e0ed27b2ab19071213106895b2806.svg";
export { ForwardRef as ReactComponent };